<template>
  <div class="search">
    <app-loader v-if="loading" />
    <app-fail-message v-else-if="getResult.totalRes === 0 || !getResult.query">
      <span v-if="!getResult.query">Bitte Suchbegriff eingeben</span>
      <span v-else>Nichts gefunden</span>
      <br>
      <v-btn
        flat
        :loading="loading"
        @click.prevent="back"
      >
        Zurück zur letzten Seite
      </v-btn>
    </app-fail-message>

    <v-container v-else>
      <v-layout>
        <v-item-group
          v-model="window"
          class="shrink mr-4"
          mandatory
          tag="v-flex"
        >
          <v-item
            v-for="category in categories"
            :key="category.id"
          >
            <div slot-scope="{ active, toggle }">
              <v-btn
                small
                flat
                :input-value="active"
                @click="toggle"
              >
                <v-icon
                  left
                  small
                >
                  {{ category.icon }}
                </v-icon>
                {{ category.name }}&nbsp;
                <span
                  v-if="category.id === 1 && getResult.movies"
                >({{ getResult.movies.length }})</span>
                <span
                  v-else-if="category.id === 2 && getResult.tvShows"
                >({{ getResult.tvShows.length }})</span>
                <span
                  v-else-if="category.id === 3 && getResult.people"
                >({{ getResult.people.length }})</span>
                <!-- <span
                  v-else-if="category.id === 4 && getResult.collections"
                >({{ getResult.collections.length }})</span> -->
              </v-btn>
            </div>
          </v-item>
        </v-item-group>


        <v-flex>
          <v-window
            v-model="window"
            class="elevation-1"
            vertical
          >
            <v-window-item
              v-for="category in categories"
              :key="category.id"
              lazy
            >
              <v-card flat>
                <v-card-text>
                  <v-layout
                    align-center
                    mb-3
                    pb-1
                  >
                    <h1 class="search__title">
                      Suchergebnisse > {{ category.name }}:
                    </h1>
                    <v-spacer />
                  </v-layout>
                  <div class="search__content">
                    <app-movie-card
                      v-if="category.id === 1 && getResult.movies.length !== 0"
                      :items="getResult"
                    />
                    <app-tv-card
                      v-else-if="category.id === 2 && getResult.tvShows.length !== 0"
                      :items="getResult"
                    />
                    <app-person-card
                      v-else-if="category.id === 3 && getResult.people.length !== 0"
                      :items="getResult"
                    />
                    <span v-else>Hamma nix...</span>
                  </div>
                </v-card-text>
              </v-card>
            </v-window-item>
          </v-window>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MovieCard from '../components/MovieCard.vue';
import TVOverviewCard from '../components/tvShows/TVOverviewCard.vue';
import PersonCard from '../components/PersonCard.vue';
import FailMessage from '../components/FailMessage.vue';


export default {
  components: {
    appMovieCard: MovieCard,
    appTvCard: TVOverviewCard,
    appPersonCard: PersonCard,
    appFailMessage: FailMessage,
  },
  data: () => ({
    window: 0,
    categories: [
      { id: 1, name: 'Filme', icon: 'movie' },
      { id: 2, name: 'Serien', icon: 'tv' },
      { id: 3, name: 'Personen', icon: 'person' },
      // { id: 4, name: 'Sammlungen', icon: 'collections' },
    ],
    // result: {
    //   query: 'Test',
    //   movies: [{ id: 299534, title: 'Avengers: Endgame', poster_path: '/or06FN3Dka5tukK1e9sl16pB3iy.jpg' }],
    //   tvShows: [{ id: 1399, name: 'Game of Thrones', poster_path: '/hDd5Zd9VMOqBeHa2agbnHZ98WWr.jpg' }],
    //   people: [{ id: 1223786, name: 'Emilia Clarke', profile_path: '/j7d083zIMhwnKro3tQqDz2Fq1UD.jpg' }],
    // },

  }),
  computed: {
    ...mapState({
      getResult(state) {
        // console.log(state.querySearch.searchData);
        // TODO: Aktivitätslist erstellen
        // Suchanfragen speichern

        return state.querySearch.searchData;
      },
    }),
    loading() {
      return this.$store.getters.loading;
    },
  },
  watch: {
    window() {
      // console.log('Window watch: ', this.window);
    },
  },
  methods: {
    loadMore() {
      this.$store.dispatch('getQueryResults', { query: this.getResult.query });
    },
    back() {
      this.$router.go(-1);
    },
    getActiveCategories() {
    },
    getActiveWindows() {

    },
  },

};
</script>

<style lang="scss" scoped>
.search {
  &__title {
    font-size: 22px;
    font-weight: 300;
    padding-left: 17px;
    padding-bottom: 5px;
    border-bottom: 1px solid #546E7A;
    width: 100%;
  }

  &__content {
    padding: 0 17px;
  }
}
</style>
